// extracted by mini-css-extract-plugin
module.exports = {"container":"ExpandOrContract_container__1j__0","icon":"ExpandOrContract_icon__2_JFP","label":"ExpandOrContract_label__Kwdgy"};